import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";

import { listServiceOrganizationApi } from "../../../../services/Admin/service";

export default function Services(props) {
    const {
        formik,
        showServiceBlock,
        showServicePvp,
        organizationName,
        organizationId,
    } = props

    const [listServices, setListServices] = useState([])
    const [servicesSelected, setServicesSelected] = useState([])

    useEffect(() => {
        getService()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getService = async () => {
        listServiceOrganizationApi(organizationId).then(resp => {
            const listServices = resp.data.data.map((doc) => {
                return {
                    id: doc.id,
                    ...doc,
                }
            })
            setListServices(listServices)
        })
    }

    // Sincroniza servicesSelected con formik.values.services cuando cambian los servicios o la organización
    useEffect(() => {
        if (formik.values.services && Array.isArray(formik.values.services)) {
            const orgServicesObj = formik.values.services.find(obj => obj[organizationId]);
            if (orgServicesObj) {
                let selectedIds = orgServicesObj[organizationId];
                // Si el primer elemento es un objeto, extrae los IDs
                if (selectedIds.length > 0 && typeof selectedIds[0] === "object") {
                    selectedIds = selectedIds.map(s => s.id);
                }
                const selectedServices = listServices.filter(s => selectedIds.includes(s.id));
                setServicesSelected(selectedServices);
            } else {
                setServicesSelected([]);
            }
        } else {
            setServicesSelected([]);
        }
    }, [formik.values.services, listServices, organizationId]);

    return (
        <>
            {showServiceBlock && (
                <Box border={1} className="p-20 mt-2 box-default">
                    <Grid container spacing={3}>
                        <Grid item md={12}>
                            <h3 className="p-0 mt-0">Servicios <span style={{ color: "#b3b3b3" }}>{organizationName}</span></h3>
                            {formik.values.idUserRole.key === "ROLE_CLIENT" ? (
                                <>
                                    <p>
                                        - Selecione los servicios que puede contratar este cliente.
                                    </p>
                                    <p>
                                        - En caso de tener un precio distinto al estandar, indicarlo en la casilla correspondiente, <strong>en caso contrario dejar en blanco</strong>
                                    </p>
                                </>
                            ) : null}

                            {formik.values.idUserRole.key === "ROLE_WORKER" ? (
                                <p>
                                    - Selecione los servicios que puede realizar este trabajador.
                                </p>
                            ) : null}

                            <Autocomplete
                                multiple
                                options={listServices}
                                value={servicesSelected}
                                getOptionLabel={(option) => (`${option.name}: ${option.name} `)}
                                fullWidth
                                size="small"
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Servicios"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />}
                                onChange={(event, newValue) => {
                                    // Actualiza solo los servicios de la organización actual, manteniendo los demás
                                    const serviceIds = newValue.map(service => service.id);
                                    let newServices = Array.isArray(formik.values.services) ? [...formik.values.services] : [];
                                    // Elimina el objeto de la organización actual si existe
                                    newServices = newServices.filter(obj => !obj[organizationId]);
                                    // Añade el nuevo objeto para la organización actual
                                    newServices.push({ [organizationId]: serviceIds });
                                    formik.setFieldValue('services', newServices);
                                }}
                            />

                            <br />

                            {showServicePvp && (
                                <>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={formik.values[`organizationId_${organizationId}_precioFijo`] || false}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    formik.setFieldValue(`organizationId_${organizationId}_precioFijo`, checked);
                                                    if (!checked) {
                                                        formik.setFieldValue(`organizationId_${organizationId}_totalFijo`, null);
                                                    }
                                                }}
                                                name="precioFijo"
                                                color="primary"
                                            />
                                        }
                                        label="Precio fijo"
                                    />
                                    <div style={{ maxWidth: "150px" }}>
                                        <TextField
                                            variant="outlined"
                                            label="* Precio Fijo (Sin IVA)"
                                            disabled={!formik.values[`organizationId_${organizationId}_precioFijo`]}
                                            className="form-control"
                                            name="totalFijo"
                                            type="text"
                                            size="small"
                                            value={formik.values[`organizationId_${organizationId}_totalFijo`] || ""}
                                            onChange={
                                                (e) => {
                                                    const value = e.target.value;
                                                    formik.setFieldValue(`organizationId_${organizationId}_totalFijo`, value);
                                                }
                                            }
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                        />
                                        {formik.errors.totalFijo && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.totalFijo}
                                            </p>
                                        )}
                                    </div>
                                </>
                            )}
                        </Grid>

                        {showServicePvp && (
                            <>
                                {listServices.map((doc, key) => {
                                    // Verifica si el servicio está seleccionado para la organización actual
                                    const orgServicesObj = Array.isArray(formik.values.services)
                                        ? formik.values.services.find(obj => obj[organizationId])
                                        : null;
                                    let selectedIds = orgServicesObj ? orgServicesObj[organizationId] : [];
                                    // Si el primer elemento es un objeto, extrae los IDs
                                    if (selectedIds.length > 0 && typeof selectedIds[0] === "object") {
                                        selectedIds = selectedIds.map(s => s.id);
                                    }
                                    if (!selectedIds.includes(doc.id)) return null;
                                    return (
                                        <Grid key={key} item md={4}>
                                            <TextField
                                                variant="outlined"
                                                label={doc.name}
                                                value={formik.values[`service_organizationId${organizationId}_serviceId${doc.id}`] || ""}
                                                className="form-control"
                                                name={`service_organizationId${organizationId}_serviceId${doc.id}`}
                                                size="small"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={formik.handleChange}
                                                fullWidth
                                                type="text"
                                                helperText={`Precio base: ${doc.pvp}/h €`}
                                            />
                                        </Grid>
                                    );
                                })}
                            </>
                        )}
                        <Grid item md={12}></Grid>

                    </Grid>
                </Box>
            )}
        </>
    )
}
